// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { opBNB as _opBNB } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the opBNB chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 204
 * Chain Name: opBNB
 * Default Block Explorer: https://mainnet.opbnbscan.com
 * Default RPC URL: https://opbnb-mainnet-rpc.bnbchain.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { opBNB } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: opBNB,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const opBNB = createCommon({
	..._opBNB,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
